export default __webpack_public_path__ + "static/media/minusLens.99989a2b.svg";